import { put, takeEvery, select } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { GA_STICKY_PANEL_BUTTON_CLICK } from 'features/page-navigation/ducks/page-navigation';
import { getRegionId } from 'features/page-model/ducks/get-model';

export type AnalyticData = {
  elementType: 'button';
  elementBlock: 'productDetail';
  elementName: 'sticky-menu';
  elementText: string;
};

export const gaStickyPanelButtonClick = createAction('GA:clickButton')<AnalyticData>();

function* putGaStickyPanelButtonClick(title: string) {
  const regionId: string = yield select(getRegionId);
  const isMoscow = regionId === '34';

  if (!isMoscow) {
    yield put(
      gaStickyPanelButtonClick({
        elementType: 'button',
        elementBlock: 'productDetail',
        elementName: 'sticky-menu',
        elementText: title,
      }),
    );
  }
}

export function* runGaStickyPanelButtonClickDetector() {
  yield takeEvery(GA_STICKY_PANEL_BUTTON_CLICK, ({ payload: { title } }) =>
    putGaStickyPanelButtonClick(title),
  );
}
